"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vendors = void 0;
const core_1 = require("../core");
/**
 * Vendors are the organizations that provide professional translation services.
 * To assign a Vendor to a project workflow you should invite an existing Organization to be a Vendor for you.
 *
 * Use API to get the list of the Vendors you already invited to your organization.
 */
class Vendors extends core_1.CrowdinApi {
    listVendors(options, deprecatedOffset) {
        if ((0, core_1.isOptionalNumber)(options, '0' in arguments)) {
            options = { limit: options, offset: deprecatedOffset };
        }
        const url = `${this.url}/vendors`;
        return this.getList(url, options.limit, options.offset);
    }
}
exports.Vendors = Vendors;
